import {
    Button, Dialog, DialogActions, DialogContent,
    DialogTitle, IconButton, Typography,
} from "@mui/material";
import {Close} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

interface SaveConfirmDialogProps {
    open: boolean;
    isNewVersion: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading?: boolean;
}

const SaveConfirmDialog = ({open, isNewVersion, onClose, onConfirm, loading}: SaveConfirmDialogProps) => {
    const {t} = useTranslation("templates");
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                {t('saveConfirmDialog.title')}
                <IconButton size="small" onClick={onClose}><Close/></IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2">
                    {isNewVersion ? t('saveConfirmDialog.messageNewVersion') : t('saveConfirmDialog.messageOverwrite')}
                </Typography>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button variant="outlined" onClick={onClose}>{t('saveConfirmDialog.cancel')}</Button>
                <Button variant="contained" color="accent" onClick={onConfirm} disabled={loading}>
                    {loading ? t('saveConfirmDialog.loading') : t('saveConfirmDialog.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveConfirmDialog;
